import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InventoryAlertsPanel = ({ alerts }) => {
  const getAlertIcon = (type) => {
    const icons = {
      'Low Stock': 'AlertTriangle',
      'Out of Stock': 'XCircle',
      'Overstock': 'TrendingUp',
      'Quality Issue': 'AlertCircle'
    };
    return icons[type] || 'Bell';
  };

  const getAlertColor = (type) => {
    const colors = {
      'Low Stock': 'bg-warning/10 text-warning border-warning/20',
      'Out of Stock': 'bg-error/10 text-error border-error/20',
      'Overstock': 'bg-primary/10 text-primary border-primary/20',
      'Quality Issue': 'bg-error/10 text-error border-error/20'
    };
    return colors[type] || 'bg-muted/10 text-muted-foreground border-muted/20';
  };

  const getPriorityColor = (priority) => {
    const colors = {
      'High': 'text-error',
      'Medium': 'text-warning',
      'Low': 'text-success'
    };
    return colors[priority] || 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1">
      <div className="flex items-center justify-between p-6 border-b border-border">
        <div className="flex items-center space-x-2">
          <h3 className="text-lg font-semibold text-foreground">Inventory Alerts</h3>
          <span className="bg-error text-error-foreground text-xs px-2 py-1 rounded-full font-medium">
            {alerts.length}
          </span>
        </div>
        <Button variant="ghost" size="sm" iconName="Settings" iconSize={16} />
      </div>

      <div className="max-h-96 overflow-y-auto">
        {alerts.length === 0 ? (
          <div className="p-8 text-center">
            <Icon name="CheckCircle" size={48} className="text-success mx-auto mb-4" />
            <p className="text-muted-foreground">No alerts at this time</p>
          </div>
        ) : (
          <div className="space-y-1">
            {alerts.map((alert, index) => (
              <div key={index} className="p-4 border-b border-border last:border-b-0 hover:bg-muted/20 transition-smooth">
                <div className="flex items-start space-x-3">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center border ${getAlertColor(alert.type)}`}>
                    <Icon name={getAlertIcon(alert.type)} size={16} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <p className="font-medium text-foreground">{alert.item}</p>
                      <span className={`text-xs font-medium ${getPriorityColor(alert.priority)}`}>
                        {alert.priority}
                      </span>
                    </div>
                    <p className="text-sm text-muted-foreground mb-2">{alert.message}</p>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                        <span>Current: {alert.currentStock}</span>
                        <span>Min: {alert.minStock}</span>
                      </div>
                      <span className="text-xs text-muted-foreground">{alert.time}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {alerts.length > 0 && (
        <div className="p-4 border-t border-border">
          <Button variant="outline" size="sm" fullWidth iconName="Eye" iconPosition="left">
            View All Alerts
          </Button>
        </div>
      )}
    </div>
  );
};

export default InventoryAlertsPanel;